module.exports = __webpack_public_path__ + "ipetbooking/admin/img/dingBeauty-logo.000c5bda.svg";